import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import apiFetch from '@wordpress/api-fetch';
import { MessageControl, DisplayControl } from './controls';
import Collapsible from './Collapsible';

const UserSettings = (endpoint) => {
  const [lessons, setLessons] = useState([]);
  const [steps, setSteps] = useState([]);
  const [userId, setuserId] = useState(null);
  const [settings, setSettings] = useState({
    id: userId,
            options: {
              warmup: false,
              explore: false,
              practice: false,
              masterycheck: false
            },
  });
  const [settingsFound, setSettingsFound] = useState(false);

  const updateSettings = (type, id, optionKey, value) => {
    console.log(`Updating ${type} ${id} ${optionKey} to ${value}`);
    setSettings(prevSettings => {
      const updatedSettings = { ...prevSettings };
      if (type === 'course') {
        updatedSettings.options[optionKey] = value;
        updateChildren(type, optionKey, value, id);
      } else if (type === 'unit') {
        const unit = updatedSettings.units.find(unit => unit.title === id);
        if (unit) {
          unit.options[optionKey] = value;
          updateChildren(type, optionKey, value, id);
        }
      } else if (type === 'lesson') {
        updatedSettings.units.forEach(unit => {
          const lesson = unit.lessons.find(lesson => lesson.id === id);
          if (lesson) {
            lesson.options[optionKey] = value;
          }
        });
      }
      return updatedSettings;
    });
  };

  const updateChildren = ( type, optionKey, value, id = null ) => {
    setSettings(prevSettings => {
      const updatedSettings = { ...prevSettings };
      if(type === 'course') {
        updatedSettings.units.forEach(unit => {
          unit.options[optionKey] = value;
          unit.lessons.forEach(lesson => {
            lesson.options[optionKey] = value;
          });
        });
      } else if (type === 'unit') {
        const unit = updatedSettings.units.find(unit => unit.title === id);
        if (unit) {
          unit.lessons.forEach(lesson => {
            lesson.options[optionKey] = value;
          });
        }
      }
      return updatedSettings;
    });
  };

  const getOptionValue = (type, id, optionKey) => {
    let value = false;
    if(settings === undefined) return value;
    if (type === 'course') {
      value = settings.options[optionKey];
    } else if (type === 'unit') {
      const unit = settings.units.find(unit => unit.title === id);
      value = unit ? unit.options[optionKey] : false;
    } else if (type === 'lesson') {
      settings.units.forEach(unit => {
        const lesson = unit.lessons.find(lesson => lesson.id === id);
        if (lesson) {
          value = lesson.options[optionKey];
        }
      });
    }
    return value;
  };

  const savePostMeta = (userId, settings) => {
    apiFetch({
      path: `/units/v1/learndash_units_settings`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        post_id: userId,
        settings: JSON.stringify(settings),
      })
    })
    .then(response => {
      console.log('Settings saved successfully:', response);
    })
    .catch(error => {
      console.error('Error saving settings:', error);
    });
  }

  useEffect(() => {
    const getuserIdFromUrl = () => {
      const params = new URLSearchParams(window.location.search);
      const userIdParam = params.get('user_id');
      if (userIdParam) {
        setuserId(parseInt(userIdParam));
        console.log(userIdParam)
      }
    };

    const getSettings = (userId) => {
      apiFetch({
        path: `/units/v1/learndash_units_settings/${userId}`,
        method: 'GET',
      })
      .then(response => {
        console.log(response)
        setSettingsFound(true);
        setSettings(JSON.parse(response.settings));
      })
      .catch(error => {
        console.error('No entry found:', error);
      });
    };
  
    getuserIdFromUrl();

    // if(userId) {
    //   getSettings(userId);
    // }

    if (userId && settingsFound === false) {
      fetch(`/wp-json/units/v1/enrolled-courses/${userId}`)
        .then(data => {
          setLessons(data);
          console.log(data.json());
        })
        .then(stepsData => {
          setSteps(stepsData);
          const unitsSettings = stepsData.sections.map(section => ({
            title: section.post_title,
            id: section.ID,
            lessons: section.steps.map(lesson => ({
              id: lesson,
              options: {
                warmup: false,
                explore: false,
                practice: false,
                masterycheck: false
              }
            })),
            options: {
              warmup: false,
              explore: false,
              practice: false,
              masterycheck: false
            }
          }));
          
          const courseSettings = {
            id: userId,
            options: {
              warmup: true,
              explore: true,
              practice: true,
              masterycheck: true
            },
            units: unitsSettings
          }; 
          console.log('Initial settings:', courseSettings)
          setSettings(courseSettings);
        })
        .catch(error => {
          console.error('Error fetching lessons:', error);
        });
    }
  }, [userId, settingsFound]);

  const renderSections = () => {
    if (!steps || !steps.sections) {
      return null; // If steps or sections are undefined, return null
    }

    return steps.sections.map(section => (
      <div key={section.id}>
        <Collapsible header={
        <div style={{display: "flex", alignItems: "center"}}>
          <h3>{section.post_title}</h3>
          <div className="section-wrapper" style={{marginLeft: "30px", display: "flex"}}>
              <div className="selection-item" style={{marginLeft: "15px", marginRight: "15px"}}>
                <p>Warm Up Solutions</p>
                <DisplayControl
                  value={ getOptionValue('unit', section.post_title, 'warmup') }
                  onChange={ ( value ) => updateSettings('unit', section.post_title, 'warmup', value) }
                />
              </div>
              <div className="selection-item" style={{marginLeft: "15px", marginRight: "15px"}}>
                <p>Explore Topic Solutions</p>
                <DisplayControl
                  value={ getOptionValue('unit', section.post_title, 'explore') }
                  onChange={ ( value ) => updateSettings('unit', section.post_title, 'explore', value) }
                />
              </div>
              <div className="selection-item" style={{marginLeft: "15px", marginRight: "15px"}}>
                <p>Practice</p>
                <DisplayControl
                  value={ getOptionValue('unit', section.post_title, 'practice') }
                  onChange={ ( value ) => updateSettings('unit', section.post_title, 'practice', value) }
                />
              </div>
              <div className="selection-item" style={{marginLeft: "15px", marginRight: "15px"}}>
                <p>Mastery Check</p>
                <DisplayControl
                  value={ getOptionValue('unit', section.post_title, 'masterycheck') }
                  onChange={ ( value ) => updateSettings('unit', section.post_title, 'masterycheck', value) }
                />
              </div>
            </div>
        </div>
        }>
        
        <div>
          {section.steps.map(lessonId => {
            const lesson = lessons.find(lesson => lesson.id === lessonId);
            return (
              <div key={lesson.id} style={{display: "flex", alignItems: "center"}}>
                <h4>{lesson.title.rendered}</h4>
                <div className="section-wrapper" style={{marginLeft: "30px", display: "flex"}}>
                  <div className="selection-item" style={{marginLeft: "15px", marginRight: "15px"}}>
                    <p>Warm Up Solutions</p>
                    <DisplayControl
                      value={ getOptionValue('lesson', lesson.id, 'warmup') }
                      onChange={ ( value ) => updateSettings('lesson', lesson.id, 'warmup', value) }
                    />
                  </div>
                  <div className="selection-item" style={{marginLeft: "15px", marginRight: "15px"}}>
                    <p>Explore Topic Solutions</p>
                    <DisplayControl
                      value={ getOptionValue('lesson', lesson.id, 'explore') }
                      onChange={ ( value ) => updateSettings('lesson', lesson.id, 'explore', value) }
                    />
                  </div>
                  <div className="selection-item" style={{marginLeft: "15px", marginRight: "15px"}}>
                    <p>Practice</p>
                    <DisplayControl
                      value={ getOptionValue('lesson', lesson.id, 'practice') }
                      onChange={ ( value ) => updateSettings('lesson', lesson.id, 'practice', value) }
                    />
                  </div>
                  <div className="selection-item" style={{marginLeft: "15px", marginRight: "15px"}}>
                    <p>Mastery Check</p>
                    <DisplayControl
                      value={ getOptionValue('lesson', lesson.id, 'masterycheck') }
                      onChange={ ( value ) => updateSettings('lesson', lesson.id, 'masterycheck', value) }
                    />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        </Collapsible>
      </div>
    ));
  };

  return (
    <div>
       <Collapsible header={
        <div style={{display: "flex", alignItems: "center"}}>
          <h4>Course</h4>
          <div className="section-wrapper" style={{marginLeft: "30px", display: "flex"}}>
            <div className="selection-item" style={{marginLeft: "15px", marginRight: "15px"}}>
              <p>Warm Up Solutions</p>
              <DisplayControl
                value={ getOptionValue('course', null, 'warmup') }
                onChange={ ( value ) => updateSettings('course', null, 'warmup', value) }
              />
            </div>
            <div className="selection-item" style={{marginLeft: "15px", marginRight: "15px"}}>
              <p>Explore Topic Solutions</p>
              <DisplayControl
                value={ getOptionValue('course', null, 'explore') }
                onChange={ ( value ) => updateSettings('course', null, 'explore', value) }
              />
            </div>
            <div className="selection-item" style={{marginLeft: "15px", marginRight: "15px"}}>
              <p>Practice</p>
              <DisplayControl
                value={ getOptionValue('course', null, 'practice') }
                onChange={ ( value ) => updateSettings('course', null, 'practice', value) }
              />
            </div>
            <div className="selection-item" style={{marginLeft: "15px", marginRight: "15px"}}>
              <p>Mastery Check</p>
              <DisplayControl
                value={ getOptionValue('course', null, 'masterycheck') }
                onChange={ ( value ) => updateSettings('course', null, 'masterycheck', value) }
              />
            </div>
          </div>
        </div>
      }>
      {renderSections()}
    </Collapsible>
      <button onClick={() => savePostMeta(userId, settings)}>
        Save Changes
      </button>
    </div>
  );
};

export { UserSettings };
